import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBrush = () => {
  return (
    <g>
      <path d="M.136 12.02c-.352-.517.024-1.209.606-1.2l.24.025c.604.04 1.372-.254 2.297-.922l.376-.278a3.924 3.924 0 0 1 1.525-.657l7.061-7.32a2.148 2.148 0 0 1 3.114 0c.824.854.858 2.217.103 3.113l-.103.114-6.823 7.074c-.175 1.725-1.873 3.094-3.985 3.029-1.64-.05-3.113-1.071-4.41-2.978zm2.033.176.052.055c.773.803 1.562 1.201 2.37 1.226 1.545.048 2.618-.971 2.475-1.998-.138-.99-1.333-1.438-2.563-.592l-.136.099c-.639.488-1.248.851-1.83 1.083l-.247.09-.12.037zm4.875-2.99c.458.218.843.558 1.11 1.001l6.163-6.387a.78.78 0 0 0 0-1.076.715.715 0 0 0-.963-.068l-.075.068-6.235 6.462z" />
    </g>
  );
};

export default withIcon(IconBrush);
